import { QuestionType } from '@/domain/impact/impact.entity';

export interface EssQuestions {
  [key: string]: EssQuestion;
}

export interface EssQuestion {
  paramId: string;
  topic: EssTopic;
  section: EssSection;
  type: QuestionType;
  title: { fr?: string; en?: string };
  options?: {
    optionId: string;
    title: { fr?: string; en?: string };
  }[];
  fields?: {
    title: { fr?: string; en?: string };
  }[];
  dependency?: {
    questions?: Array<string>;
    rules?: Array<{
      conditions: {
        $eq: boolean | string | number;
      };
      value: boolean;
    }>;
  };
}

export type EssQuestionValue = {
  id: number;
  paramId: string;
  value: string;
  score?: number;
  projectId?: number;
};

export enum EssSection {
  ARTISTIC_TEAM = 'ARTISTIC_TEAM',
  PERMANENT_OPERATIONAL_TEAM = 'PERMANENT_OPERATIONAL_TEAM',
  OCCASIONAL_OPERATIONAL_TEAM = 'OCCASIONAL_OPERATIONAL_TEAM',
  TRANSPARENCY_MANAGEMENT = 'TRANSPARENCY_MANAGEMENT',
  ACCESSIBILITY = 'ACCESSIBILITY',
  RISK_PREVENTION = 'RISK_PREVENTION',
  VOLUNTEERS = 'VOLUNTEERS',
  LOCALITY_EMPLOYMENT_PARTNERS = 'LOCALITY_EMPLOYMENT_PARTNERS',
  ECONOMIC_SOCIAL_IMPACT = 'ECONOMIC_SOCIAL_IMPACT',
  COMMUNICATION = 'COMMUNICATION',
  TEAM_MANAGEMENT = 'TEAM_MANAGEMENT',
  PERMANENT_PRODUCTION_TEAM = 'PERMANENT_PRODUCTION_TEAM',
}

export enum EssTopic {
  PARITY_EQUALITY = 'PARITY_EQUALITY',
  ACCESSIBILITY_SOCIAL_DIALOGUE = 'ACCESSIBILITY_SOCIAL_DIALOGUE',
  LOCAL_IMPACT_RSE_ENGAGEMENT = 'LOCAL_IMPACT_RSE_ENGAGEMENT',
}
